import axios from "axios";

const endpoint_url = "/message/messageBlasting/detail";

const getMessageDetail = (messageUuid) => {
  const params = new URLSearchParams([['message_uuid', messageUuid]]);

  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, { params })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getMessageDetail;
